import React, { useEffect, useState } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css'; // ✅ make sure you import the CSS
import slider1 from '../../assets/images/slider/1.png';
import { endpoint } from '../../utils/endpoints';

const fallbackSlides = [
  {
    title: 'AI-Powered Food Ordering System',
    description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et',
    image: slider1,
  },
  {
    title: 'AI-Powered Food Ordering System',
    description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et',
    image: slider1,
  },
  {
    title: 'AI-Powered Food Ordering System',
    description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et',
    image: slider1,
  },
];

const parseBannerList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

const getValidBannerSlides = (list) =>
  list
    .filter((banner) => banner?.title && banner?.description && banner?.image)
    .map((banner) => ({
      id: banner._id,
      title: banner.title,
      description: banner.description,
      image: banner.image,
    }));

function Slider() {
  const [slides, setSlides] = useState(fallbackSlides);

  useEffect(() => {
    const getBanners = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_ACCOUNTANT_API}${endpoint.banners}`);
        const result = await response.json();
        const list = parseBannerList(result);
        const validSlides = getValidBannerSlides(list);

        if (validSlides.length > 0) {
          setSlides(validSlides);
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    };

    getBanners();
  }, []);

  return (
    <>
      <Splide options={{type : 'loop', perPage: 1, perMove: 1, rewind : true, gap: '1rem',}} className="[&_h2]:text-[32px] md:[&_h2]:text-[65px] 2xl:[&_h2]:text-[90px] [&_h2]:font-PxBold [&_h2]:leading-[46px] md:[&_h2]:leading-[70px] 2xl:[&_h2]:leading-[100px] [&_p]:text-lg 2xl:[&_p]:text-[22px] [&_p]:font-PxThin [&_button]:mx-1 [&_button]:!transform-none [&_button]:opacity-100 [&_ul.splide\_\_pagination_button]:w-[14px] [&_ul.splide\_\_pagination_button]:h-[14px] [&_ul.splide\_\_pagination_button]:bg-[rgba(255,255,255,.20)] [&_button.is-active]:bg-gradient-to-t from-[#2590F3] via-[#26BBF8] to-[#2CF6FE] [&_button.is-active]:!w-9 [&_button.is-active]:rounded-lg [&_.splide\_\_arrows]:hidden text-center sm:text-left px-3 md:px-16">
        {slides.map((slide, index) => (
          <SplideSlide key={slide?.id || `${slide.title}-${index}`}>
            <div className="max-w-screen-2xl mx-auto flex flex-col sm:grid grid-cols-2 2xl:px-6 items-center py-8 2xl:py-14">
              <div className="text-white flex flex-col gap-y-3 md:gap-y-8 order-2 sm:-order-1 px-4 md:px-0 my-4 my:mt-0">
                <h2>{slide.title}</h2>
                <p className='md:pr-28 2xl:pr-36'>{slide.description}</p>
              </div>
              <div>
                <img src={slide.image} alt={slide.title} className='max-w-[100%] block mx-auto'/>
              </div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </>
  );
}

export default Slider;
